/**
 * @param {EventApiProps} event
 * @returns {EventTeaserProps}
 */
const mapEventProps = (event) => ({
  title: event.title,
  startTime: event.eventStart,
  endTime: event.eventEnd,
  website: event.website,
  eventContact: event.contactOrLocation,
});

export default mapEventProps;
